var map = {
	"./desktop": 18,
	"./desktop.js": 18,
	"./desktop.scss": 4,
	"./desktopUtils": 11,
	"./desktopUtils.js": 11,
	"./mobile": 19,
	"./mobile.js": 19,
	"./mobile.scss": 3,
	"./mobileUtils": 6,
	"./mobileUtils.js": 6
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;


//////////////////
// WEBPACK FOOTER
// ./templates/header ^\.\/.*$
// module id = 51
// module chunks = 0